export const ROUTE_AUTH_TOKEN_REFRESH = '/customer/account/login/refresh'
export const ROUTE_AUTH_TOKEN_REDIRECT = '/customer/account/login/redirect'
